import React, { memo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { TabList as ReactTabsTabList } from 'react-tabs';

import { ChildrenPropType } from '../../../../prop-types/children';

import style from './tab-list.module.less';

const TabList = memo(({ className, children, ...rest }) => (
  <ReactTabsTabList className={classnames(style['tab-list'], className)} {...rest}>
    {children}
  </ReactTabsTabList>
));

// required for react-tabs implementation
TabList.tabsRole = 'TabList';

export { TabList };

TabList.propTypes = {
  className: PropTypes.string,
  children: ChildrenPropType,
};
